/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_Delete_HintInputs */

const vi_meeting_guest_delete_hint = /** @type {(inputs: Meeting_Guest_Delete_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ xoá được người chưa dự cuộc họp nào. Nếu nhập sai tên, hãy sửa lại thay vì xoá.`)
};

/**

* @param {Meeting_Guest_Delete_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_delete_hint = /** @type {((inputs?: Meeting_Guest_Delete_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Delete_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_delete_hint(inputs)
});